const KeenSlider = window.KeenSlider

const { useDots } = window.BAO.Carousel.plugins

const { setInitialised, useArrows, useProgress } = window.BAO.Carousel.plugins

class SectionMarketingCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slide?.exists) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.1,
          spacing: 0,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 1.6,
              spacing: 80,
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: 1.2,
              spacing: 0,
            },
          }
        },
      },
      [
        setInitialised(),
        useArrows({
          container: this.els?.arrows?.element,
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
        useProgress({
          container: this.els?.progress?.element,
          progressbar: this.els?.progressbar?.element,
        }),
        useDots(this.els?.dot?.elements),
      ],
    )
  }
}

if (!customElements.get('section-marketing-carousel')) {
  customElements.define('section-marketing-carousel', SectionMarketingCarousel)
}
